import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/football', label: '足球竞猜' },
  { path: '/category/basketball', label: '篮球竞猜' },
  { path: '/category/tennis', label: '网球竞猜' },
  { path: '/category/esports', label: '电竞竞猜' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
              <i className="ri-fire-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-900 whitespace-nowrap">
              华体会官网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-accent-700 bg-accent-100'
                    : 'text-foreground-700 hover:text-accent-700 hover:bg-accent-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="px-4 py-2 text-sm font-medium text-background-50 bg-accent-500 rounded-md hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap"
            >
              立即注册
            </a>
            <a
              href="#"
              className="px-4 py-2 text-sm font-medium text-accent-700 border border-accent-300 rounded-md hover:bg-accent-50 transition-colors duration-200 whitespace-nowrap"
            >
              会员登录
            </a>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-accent-700 bg-accent-100'
                    : 'text-foreground-700 hover:text-accent-700 hover:bg-accent-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-3 pt-3 border-t border-background-200/70">
              <a
                href="#"
                className="flex-1 px-4 py-2.5 text-sm font-medium text-background-50 bg-accent-500 rounded-md hover:bg-accent-600 transition-colors duration-200 text-center whitespace-nowrap"
              >
                立即注册
              </a>
              <a
                href="#"
                className="flex-1 px-4 py-2.5 text-sm font-medium text-accent-700 border border-accent-300 rounded-md hover:bg-accent-50 transition-colors duration-200 text-center whitespace-nowrap"
              >
                会员登录
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}